import { useState } from 'react';
import { faqs } from '@/mocks/siteContent';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="text-xs md:text-sm label-font text-primary-600 tracking-[0.2em]">
            FAQ
          </span>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于合集整理方式、更新机制与内容来源，这里集中解答。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                    {item.q}
                  </h3>
                  <span
                    className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-3">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}